<template>
  <div>
    <BusinessViewHeader
      :business="business"
      :is_loading="is_loading"
      :is_owner="is_owner"
      @on-scroll-to="scroll_to"
    ></BusinessViewHeader>

    <div class="pt-8 pb-4 white text-center pr-8">
      <v-btn
        v-for="(btn, index) in header_buttons"
        :key="index"
        small
        rounded
        class="mr-4"
        outlined
        :disabled="is_loading"
        :color="btn.color"
        @click="on_click_header_action(btn)"
      >
        <v-icon left>{{ btn.icon }}</v-icon
        >{{ btn.label }}
      </v-btn>
    </div>

    <CardedSectionHeader
      icon="mdi-form-select"
      label="Description"
      id="owner_view_business_description_section"
    ></CardedSectionHeader>
    <BusinessViewDescription
      :business="business"
      :is_loading="is_loading"
      :is_owner="is_owner"
    >
    </BusinessViewDescription>
    <CardedSectionHeader
      icon="mdi-star"
      label="Please Rate This Business"
      id="owner_view_business_rate_form_section"
    ></CardedSectionHeader>
    <BusinessViewRateForm
      :business="business"
      :is_loading="is_loading"
      :is_owner="is_owner"
      :user="$data._user"
      @on-success-rated="finished_rating_business"
      @on-not-loggedin="no_rate_user_not_loggedin"
    >
    </BusinessViewRateForm>
    <CardedSectionHeader
      icon="mdi-map"
      label="Location"
      id="owner_view_business_location_section"
    >
      <v-btn
        small
        rounded
        class="mr-4"
        outlined
        :disabled="is_loading"
        color="success"
        v-if="is_owner"
        :to="
          '/owner/businesses/list/view/' +
          this.business_id +
          '/locations/manage'
        "
      >
        <v-icon left>mdi-pen</v-icon>
        Manage Location Info
      </v-btn>
    </CardedSectionHeader>
    <BusinessViewLocation
      :business="business"
      :is_loading="is_loading"
      :is_owner="is_owner"
    >
    </BusinessViewLocation>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Working Schedules "
      id="owner_view_business_working_schedules_section"
    >
      <v-btn
        small
        rounded
        class="mr-4"
        outlined
        :disabled="is_loading"
        color="success"
        v-if="is_owner"
        :to="
          '/owner/businesses/list/view/' + this.business_id + '/holidaysschedule/manage'
        "
      >
        <v-icon left>mdi-pen</v-icon>
        Manage Holidays Schedule
      </v-btn>

      <v-btn
        small
        rounded
        class="mr-4"
        outlined
        :disabled="is_loading"
        color="success"
        v-if="is_owner"
        :to="
          '/owner/businesses/list/view/' + this.business_id + '/schedule/manage'
        "
      >
        <v-icon left>mdi-pen</v-icon>
        Manage Weekly Schedule
      </v-btn>
    </CardedSectionHeader>
    <BusinessViewSchedule
      :business="business"
      :is_loading="is_loading"
      :is_owner="is_owner"
      :key="business_schedule_key"
    >
    </BusinessViewSchedule>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Contact Information"
      id="owner_view_business_contact_info_section"
    >
      <v-btn
        small
        rounded
        class="mr-4"
        outlined
        :disabled="is_loading"
        color="success"
        v-if="is_owner"
        :to="
          '/owner/businesses/list/view/' + this.business_id + '/contacts/manage'
        "
      >
        <v-icon left>mdi-pen</v-icon>
        Manage Contact Info
      </v-btn>
    </CardedSectionHeader>
    <BusinessViewContacts
      :business="business"
      :is_loading="is_loading"
      :is_owner="is_owner"
    >
    </BusinessViewContacts>

    <CardedSectionHeader
      icon="mdi-form-select"
      label="Contact This Business Via a Message"
      id="owner_view_business_contact_us_form_section"
    ></CardedSectionHeader>

    <CardedSectionHeader
      icon="mdi-form-select"
      label="Business Photo Gallery "
      id="owner_view_business_photo_gallery_section"
    ></CardedSectionHeader>

    <CardedSectionHeader
      icon="mdi-form-select"
      label="Business Meta Data "
      id="owner_view_business_meta_section"
    ></CardedSectionHeader>
    <div>
      Meta data includes also the hash tags , verification, join date, etc facts
    </div>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Please Review This Business"
      id="owner_view_business_review_form_section"
    ></CardedSectionHeader>

    <CardedSectionHeader
      icon="mdi-form-select"
      label="Business Searches List "
      id="owner_view_business_searches_list_section"
    ></CardedSectionHeader>

    <CardedSectionHeader
      icon="mdi-form-select"
      label="Business Views List "
      id="owner_view_business_views_list_section"
    ></CardedSectionHeader>

    <CardedSectionHeader
      icon="mdi-form-select"
      label="Business Ratings List "
      id="owner_view_business_ratings_list_section"
    ></CardedSectionHeader>

    <CardedSectionHeader
      icon="mdi-form-select"
      label="Business Reviews List "
      id="owner_view_business_reviews_list_section"
    ></CardedSectionHeader>

    <CardedSectionHeader
      icon="mdi-form-select"
      label="Business Messages List "
      id="owner_view_business_messages_list_section"
    ></CardedSectionHeader>

    <CardedSectionHeader
      icon="mdi-form-select"
      label="Business Activity Graph "
      id="owner_view_business_activity_graph_section"
    ></CardedSectionHeader>

    <br />
  </div>
</template>

<script>
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
import CardedSectionHeader from "./../../../components/CardedSectionHeader";
import PlainDisplay from "./../../../components/PlainDisplay";
import BusinessViewHeader from "./../../../components/BusinessViewHeader";
import BusinessViewDescription from "./../../../components/BusinessViewDescription";
import BusinessViewRateForm from "./../../../components/BusinessViewRateForm";
import BusinessViewLocation from "./../../../components/BusinessViewLocation";
import BusinessViewSchedule from "./../../../components/BusinessViewSchedule";
import BusinessViewContacts from "./../../../components/BusinessViewContacts";


import CardedDisplay from "./../../../components/CardedDisplay";
export default {
  name: "OwnerBusinessesView",
  components: {
    CardedSectionHeader,
    CardedDisplay,
    PlainDisplay,
    BusinessViewHeader,
    BusinessViewDescription,
    BusinessViewRateForm,
    BusinessViewLocation,
    BusinessViewSchedule,
    BusinessViewContacts
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      business_id: 0,
      _user: null,
      business: Utils.get_default_business(),
      is_owner: false,
      business_schedule_key: "bsk_1",
      business_schedule_key_count: 1
    };
  },
  methods: {
    send_parent_page_set_up() {
      if (this.is_owner) {
        this.$emit("set-page-attributes", {
          title: "Business Details",
          crumps: [
            {
              text: "Owner",
              disabled: false,
              href: "/owner",
            },
            {
              text: "Buinesses",
              disabled: false,
              href: "/owner/businesses/",
            },
            {
              text: "List",
              disabled: false,
              href: "/owner/businesses/list",
            },
            {
              text: "View",
              disabled: true,
              href: "/owner/businesses/list/view/" + this.business_id,
            },
          ],
          navbar_cols: 3,
          quick_page_links: [],
        });
      } else {
        this.$emit("set-page-attributes", {
          title: "Business Details",
          crumps: [
            {
              text: "Home",
              disabled: false,
              href: "/",
            },
            {
              text: "List",
              disabled: false,
              href: "/businesses/",
            },
            {
              text: "View",
              disabled: true,
              href: "/businesses/view/" + this.business_id,
            },
          ],
          quick_page_links: [],
        });
      }
    },
    load_business(id) {
      this.$emit("on-show-loader");
      ServerClient.Businesses.get_my_business(
        {
          id: id,
          user_id: this._user ? this._user.id : 0,
        },
        (res) => {
          this.$emit("on-hide-loader");
          if (res) {
            //force schedule to be redrawn
            this.business_schedule_key_count = this.business_schedule_key_count + 1;
            this.business_schedule_key = "bsk_" + this.business_schedule_key_count;
            this.business = res;
            if (
              this._user &&
              this._user != null &&
              parseInt(this._user.id) == parseInt(this.business.user_id)
            ) {
              this.is_owner = true;
              this.send_parent_page_set_up();
            }
            
            
          }
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log("Errors while loading owners my business ", errors);
        }
      );
    },
    go_to_category(category_id) {
      this.$router.push("/categories/" + category_id);
    },
    go_to_sub_category(category_id, sub_category_id) {
      this.$router.push(
        "/categories/" + category_id + "/sub_category/" + sub_category_id
      );
    },
    on_click_header_action(btn) {
      switch (btn.action) {
        case "rate_us":
          this.scroll_to("owner_view_business_rate_form_section");
          break;
        case "review_us":
          this.scroll_to("owner_view_business_review_form_section");
          break;
        case "message_us":
          this.scroll_to("owner_view_business_contact_us_form_section");
          break;
        case "verify":
          this.$router.push(
            "/owner/businesses/list/view/" + this.business_id + "/verify"
          );
          break;
        case "edit_banner_image":
          this.$router.push(
            "/owner/businesses/list/view/" + this.business_id + "/edit_banner"
          );
          break;
        case "edit_basic_info":
          this.$router.push(
            "/owner/businesses/list/view/" + this.business_id + "/edit_info"
          );
          break;
        case "delete":
          this.$router.push(
            "/owner/businesses/list/view/" + this.business_id + "/delete"
          );
          break;
        default:
          break;
      }
    },
    scroll_to(id) {
      var options = {
        offset: 60,
        duration: 1000,
        easing: "easeInOutCubic",
      };
      this.$vuetify.goTo("#" + id, options);
    },
    finished_rating_business() {
      //reload
      this.business_id = parseInt(this.$route.params.id);
      this.load_business(this.business_id);
    },
    no_rate_user_not_loggedin(rate) {
      this.$emit("on-show-login-modal", {
        action: "rating_business",
        value: rate,
      });
    },
  },
  computed: {
    header_buttons() {
      var is_owner = this.is_owner;
      var is_admin = Utils.is_admin(this._user);

      var ls = [];
      //rate us button
      //should not display if its the owner &&
      //if its the admin
      if (is_owner == false && is_admin == false) {
        ls.push({
          action: "rate_us",
          color: "success",
          icon: "mdi-pen",
          label: "Rate Us",
        });
      }
      //review button
      if (is_owner == false && is_admin == false) {
        ls.push({
          action: "review_us",
          color: "success",
          icon: "mdi-pen",
          label: "Leave a review",
        });
      }
      //send message
      //also admin can send the business a message
      if (is_owner == false) {
        ls.push({
          action: "message_us",
          color: "success",
          icon: "mdi-pen",
          label: "Send Us a Message",
        });
      }
      //verify
      //only the owner can verify the business
      if (is_owner == true) {
        ls.push({
          action: "verify",
          color: "success",
          icon: "mdi-pen",
          label: "Verify Business",
        });
      }
      //edit basic info & delete
      if (is_owner == true) {
        ls.push({
          action: "edit_banner_image",
          color: "warning",
          icon: "mdi-pen",
          label: "Edit Banner Image",
        });
        ls.push({
          action: "edit_basic_info",
          color: "warning",
          icon: "mdi-pen",
          label: "Edit Basic Info",
        });
        ls.push({
          action: "delete",
          color: "red",
          icon: "mdi-times",
          label: "Delete",
        });
      }
      return ls;
    },
  },
  mounted() {
    //   console.log(this.$route.params);
    this.business_id = parseInt(this.$route.params.id);
    this._user = ServerClient.Login.get_logged_in_user();
    this.$emit("set-page-attributes", {
      title: "Business Details",
      crumps: [
        {
          text: "Home",
          disabled: false,
          href: "/",
        },
        {
          text: "Buinesses",
          disabled: false,
          href: "/businesses/",
        },
        {
          text: "View",
          disabled: true,
          href: "businesses/view/" + this.business_id,
        },
      ],
    });
    this.load_business(this.business_id);
  },
};
</script>

